import React from "react";

import { useTranslation } from "react-i18next";

import { ResolutionType } from "../../../store/common_types";
import { Selector } from "../selector";

export interface ResolutionSelectorProps {
  resolution: ResolutionType;
  options?: ResolutionType[];
  onSelect: (resolution: ResolutionType) => void;
  rangeDiffDay?: number;
}

export const resolutionOptions: ResolutionType[] = ["10min", "1h", "1d", "1m"];

const disableMap: Record<ResolutionType, (rangeDiffDays: number) => boolean> = {
  "10min": (rangeDiffDays: number): boolean => rangeDiffDays > 7,
  "1h": (rangeDiffDays: number): boolean => rangeDiffDays > 31,
  "1d": (rangeDiffDays: number): boolean => rangeDiffDays > 31 * 6,
  "1m": (_: number): boolean => false,
};

export const ResolutionSelector: React.FC<ResolutionSelectorProps> = (props) => {
  const { t } = useTranslation("resolution_selector");
  const resolution = props.options ?? resolutionOptions;
  return (
    <Selector
      title={t("title")}
      value={props.resolution}
      placeholder={t("placeholder")}
      options={resolution.map((value) => ({
        value,
        title: t(`options.${value}`),
        disabled: props.rangeDiffDay ? disableMap[value](props.rangeDiffDay) : false,
      }))}
      onSelect={(value) => props.onSelect(value as ResolutionType)}
    />
  );
};
